import { z } from 'zod';
import { recordingPackagesSchema } from './workflow';

/** Upload-only capabilities are random opaque tokens, never playback credentials. */
export const RAW_PACKAGE_UPLOAD_GRANT_TTL_SECONDS = 900;
export const rawPackageUploadGrantTokenSchema = z.string().length(64).regex(/^[0-9a-f]{64}$/);
export const rawPackageUploadGrantRequestSchema = z.object({
  hostId: z.string().min(1).max(128),
  /** Exact approved remote session; direct authenticated local Hosts omit this. */
  hostSessionId: z.string().uuid().optional(),
  packages: recordingPackagesSchema.refine(rows => new Set(rows.map(row => row.packageId.toLowerCase())).size === rows.length,
    'Package ids must be unique'),
  /** Refresh this still-live capability without changing its exact authority or package scope. */
  renewToken: rawPackageUploadGrantTokenSchema.optional(),
}).strict();
export const rawPackageUploadGrantResponseSchema = z.object({
  token: rawPackageUploadGrantTokenSchema,
  expiresAtUnixMs: z.number().int().positive().safe(),
}).strict();
export type RawPackageUploadGrantRequest = z.infer<typeof rawPackageUploadGrantRequestSchema>;
export type RawPackageUploadGrantResponse = z.infer<typeof rawPackageUploadGrantResponseSchema>;
